/**
 * lycrud需要经常用到的数据对象/数组
 */
export default {
    // 启用 true/ 禁用 false
    STATUS_BOOL:[{ label: '启用', value: true }, { label: '禁用', value: false }],
    // 启用 1/ 禁用 0
    STATUS_NUMBER:[{ label: '启用', value: 1 }, { label: '禁用', value: 0 }],
    // 是 1/ 否 0
    WHETHER_NUMBER:[{ label: '是', value: 1 }, { label: '否', value: 0 }],
    // 是 true/ 否 false
    WHETHER_APP:[{ label: 'IOS', value: 0 }, { label: '安卓', value: 1 },{ label: '鸿蒙', value: 2 }],
    // 
    WHETHER_BOOL:[{ label: '是', value: true }, { label: '否', value: false }],
    // 
    WHETHER_ONLINEFLAG:[{ label: '离线', value: 0 },{ label: '在线', value: 1 },{ label: '操作中', value: 2 }],
    //添加设备类型
    DEVICE_TYPE:[{label: 'ANL_8260_HART', value: 'ANL_8260_HART'},{label: 'ANL_8260_485', value: 'ANL_8260_485'},{label: 'ANL_9107', value: 'ANL_9107'},
                 {label: 'ANL_9107_485', value: 'ANL_9107_485'},{label: 'ANL_9107HT', value: 'ANL_9107HT'},{label: 'ANL_9127', value: 'ANL_9127'},
                 {label: 'ANL_9127HT', value: 'ANL_9127HT'},{label: 'ANL_8010', value: 'ANL_8010'},{label: 'ANL_9080', value: 'ANL_9080'},
                 {label: 'ANL_8260HB', value: 'ANL_8260HB'},{label: 'AIW_4110', value: 'AIW_4110'},{label: 'AIW_4111', value: 'AIW_4111'},
                 {label: 'AIW_4111_SOLID', value: 'AIW_4111_SOLID'},{label: 'AIW_4112', value: 'AIW_4112'},{label: 'AIW_4120', value: 'AIW_4120'},{label: 'AIW_5112', value: 'AIW_5112'}
                //  ,{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{}
                ]
}